"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JustView = exports.JustForm = exports.WToggle = void 0;

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var detail_1 = __importDefault(require("../../data/detail"));

var form_1 = __importDefault(require("../../data/form"));

exports.WToggle = function (props) {
  var ViewUI = props.ViewUI,
      FormUI = props.FormUI,
      Data = props.Data,
      data = props.data;
  return react_1.default.createElement(detail_1.default, {
    data: data,
    ViewUI: ViewUI,
    FormUI: FormUI,
    promise: Data.update
  });
};

exports.JustForm = function (props) {
  var FormUI = props.FormUI,
      Data = props.Data,
      linkBack = props.linkBack,
      data = props.data;
  var history = react_router_dom_1.useHistory();

  var onUpdate = function onUpdate(x) {
    return history.push(linkBack);
  };

  return react_1.default.createElement(form_1.default, {
    data: data,
    UI: FormUI,
    promise: Data.update,
    onUpdate: onUpdate
  });
};

exports.JustView = function (props) {
  var ViewUI = props.ViewUI,
      data = props.data;
  return react_1.default.createElement(ViewUI, {
    data: data
  });
};

exports.default = exports.WToggle;